// document.addEventListener("DOMContentLoaded", function () {
//   function e() {
//     document.querySelectorAll(".cart-upsell").forEach(function (e) {
//       const selectElement = e.querySelector(".cart-upsell__select");
//       const imageElement = e.querySelector(".cart-upsell__image img");
//       const priceElement = e.querySelector(
//         ".cart-upsell__price span.line-through"
//       );
//       const discountElement = e.querySelector(".cart-upsell__price span.red");

//       selectElement.addEventListener("change", function (t) {
//         const selectedOption = t.target.selectedOptions[0];
//         const n = selectedOption.getAttribute("data-image");
//         const discount = selectedOption.getAttribute("data-discounted");
//         const price = selectedOption.getAttribute("data-price");

//         if (imageElement && n) {
//           imageElement.src = n;
//         } else {
//           console.warn("Image element or data-image value is missing!");
//         }

//         if (priceElement && price) {
//           priceElement.textContent = price;
//         }

//         if (discountElement && discount) {
//           discountElement.textContent = discount;
//         }
//       });

//       // Trigger the change event on page load
//       const selectedOption = selectElement.selectedOptions[0];
//       if (selectedOption) {
//         selectElement.dispatchEvent(new Event("change"));
//       }
//     });
//   }

//   e();

//   new MutationObserver(e).observe(document.body, {
//     childList: !0,
//     subtree: !0,
//   });
// });

document.addEventListener("DOMContentLoaded", function () {
  function e() {
    document.querySelectorAll(".cart-upsell").forEach(function (e) {
        var priceElement = e.querySelector(".cart-upsell__price span.line-through");
        var discountElement = e.querySelector(".cart-upsell__price span.red");

      e.querySelector(".cart-upsell__select").addEventListener(
        "change",
        function (t) {
        var discount = t.target.selectedOptions[0].getAttribute("data-discounted");
        var price = t.target.selectedOptions[0].getAttribute("data-price");
        
        const n = t.target.selectedOptions[0].getAttribute("data-image"),
            c = e.querySelector(".cart-upsell__image img");
          c && n
            ? (c.src = n)
            : console.warn("Image element or data-image value is missing!");

            priceElement && price ? (priceElement.textContent = price) : null;
            discountElement && discount ? (discountElement.textContent = discount) : null;
            
        }
      );
      
    });
  }
  e(),
    new MutationObserver(e).observe(document.body, {
      childList: !0,
      subtree: !0,
    });
});

